<template>
  <footer class="site-footer">
    <!-- Newsletter ribbon -->
    <div class="container">
      <div class="newsletter">
        <div class="newsletter-copy">
          <h3>نکات آیلتس در ایمیل شما</h3>
          <p>استراتژی مطالعه، آزمون‌های جدید و توصیه نمره — هفته‌ای یک‌بار، بدون اسپم.</p>
        </div>
        <form class="newsletter-form" @submit.prevent>
          <input type="email" placeholder="you@example.com" aria-label="آدرس ایمیل" />
          <button type="submit" class="btn-subscribe">
            عضویت <i class="bi bi-send-fill"></i>
          </button>
        </form>
      </div>
    </div>

    <div class="container footer-main">
      <div class="footer-grid">
        <!-- Brand -->
        <div class="footer-brand-col">
          <router-link to="/dashboard" class="footer-brand">
            <BrandLogo size="lg" />
          </router-link>
          <p class="footer-tagline">
            آزمون‌های شبیه‌سازی آیلتس کامپیوتری واقع‌گرایانه و تمرین —
            برای رسیدن به نمره هدف با اطمینان.
          </p>
          <div class="socials">
            <a v-for="s in socials" :key="s.label" :href="s.url" :aria-label="s.label" class="social">
              <i :class="s.icon"></i>
            </a>
          </div>
        </div>

        <!-- Link columns -->
        <div class="footer-col" v-for="col in columns" :key="col.title">
          <h6>{{ col.title }}</h6>
          <ul>
            <li v-for="link in col.links" :key="link.text">
              <router-link v-if="link.to" :to="link.to">{{ link.text }}</router-link>
              <a v-else :href="link.url || '#'">{{ link.text }}</a>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-col">
          <h6>تماس</h6>
          <ul class="contact-list">
            <li><i class="bi bi-envelope"></i> info@cocouni.com</li>
            <li><i class="bi bi-telephone"></i> +1 (000) 123-4567</li>
            <li><i class="bi bi-geo-alt"></i> در سراسر جهان، آنلاین</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <p>© {{ year }} CocoUni. تمامی حقوق محفوظ است.</p>
        <ul class="legal">
          <li><a href="#">حریم خصوصی</a></li>
          <li><a href="#">شرایط استفاده</a></li>
          <li><a href="#">کوکی‌ها</a></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import BrandLogo from "@/components/BrandLogo.vue";

const year = new Date().getFullYear();

const socials = [
  { label: "Instagram", icon: "bi bi-instagram", url: "#" },
  { label: "Twitter / X", icon: "bi bi-twitter-x", url: "#" },
  { label: "YouTube", icon: "bi bi-youtube", url: "#" },
  { label: "LinkedIn", icon: "bi bi-linkedin", url: "#" },
];

const columns = [
  {
    title: "تمرین",
    links: [
      { text: "داشبورد", to: "/dashboard" },
      { text: "آزمون‌های آزمایشی", to: "/mock-exams" },
      { text: "تمرین ریدینگ", to: "/reading-practice" },
      { text: "تمرین رایتینگ", to: "/writing-exercises" },
      { text: "تمرین شفاهی", to: "/oral-practice" },
    ],
  },
  {
    title: "شرکت",
    links: [
      { text: "درباره ما", url: "#" },
      { text: "سوابق تمرین", to: "/practice-records" },
      { text: "همکاری با ما", url: "#" },
      { text: "وبلاگ", url: "#" },
    ],
  },
];
</script>

<style scoped>
.site-footer {
  background: radial-gradient(120% 120% at 0% 0%, #142a7a 0%, #0b1437 55%, #070d24 100%);
  color: #cbd5e1;
  margin-top: 4rem;
}

/* Newsletter */
.newsletter {
  transform: translateY(-2rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
  background: var(--grad-brand);
  border-radius: var(--radius-md);
  padding: 1.75rem 2rem;
  box-shadow: var(--shadow-lg);
}
.newsletter-copy h3 {
  color: #fff;
  font-weight: 800;
  margin: 0 0 0.3rem;
  font-size: 1.3rem;
}
.newsletter-copy p {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.92rem;
}
.newsletter-form {
  display: flex;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 0.35rem;
  border-radius: 999px;
  min-width: min(100%, 360px);
}
.newsletter-form input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  padding: 0.5rem 1rem;
  color: var(--ink-900);
  font-size: 0.92rem;
}
.btn-subscribe {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  background: var(--ink-900);
  color: #fff;
  font-weight: 700;
  border-radius: 999px;
  padding: 0.55rem 1.2rem;
  white-space: nowrap;
  transition: transform 0.2s ease, background 0.2s ease;
}
.btn-subscribe:hover {
  background: var(--brand-700);
  transform: translateY(-2px);
}

/* Main */
.footer-main {
  padding: 1rem 0 2.5rem;
}
.footer-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.2fr;
  gap: 2rem;
}
.footer-brand {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  margin-bottom: 1rem;
}
.footer-tagline {
  font-size: 0.92rem;
  line-height: 1.65;
  color: #94a3b8;
  max-width: 22rem;
  margin-bottom: 1.25rem;
}
.socials {
  display: flex;
  gap: 0.6rem;
}
.social {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.07);
  color: #cbd5e1;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}
.social:hover {
  background: var(--brand-600);
  color: #fff;
  transform: translateY(-3px);
}

.footer-col h6 {
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  margin-bottom: 1.1rem;
}
.footer-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-col li { margin-bottom: 0.6rem; }
.footer-col a {
  color: #94a3b8;
  text-decoration: none;
  font-size: 0.92rem;
  transition: color 0.2s ease, padding-left 0.2s ease;
}
.footer-col a:hover {
  color: #fff;
  padding-left: 4px;
}
.contact-list li {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.9rem;
  color: #94a3b8;
}
.contact-list i { color: var(--brand-300); }

/* Bottom */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1.2rem 0;
}
.footer-bottom-inner p {
  margin: 0;
  font-size: 0.85rem;
  color: #94a3b8;
}
.legal {
  display: flex;
  gap: 1.25rem;
  list-style: none;
  padding: 0;
  margin: 0;
}
.legal a {
  color: #94a3b8;
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.2s ease;
}
.legal a:hover { color: #fff; }

@media (max-width: 991.98px) {
  .footer-grid { grid-template-columns: 1fr 1fr; gap: 2rem 1.5rem; }
  .footer-brand-col { grid-column: 1 / -1; }
}
@media (max-width: 575.98px) {
  .newsletter { padding: 1.4rem; }
  .footer-grid { grid-template-columns: 1fr; }
  .footer-bottom-inner { flex-direction: column; }
}
</style>
